import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Chilean RUT generator following Single Responsibility Principle
 */
export class RutGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate 7-8 digits
    const digitCount = this.randomInt(7, 8);
    const digits = this.randomDigits(digitCount);
    
    // Calculate check digit
    const checksum = ChecksumCalculator.calculateRutChecksum(digits);
    
    if (formatted) {
      if (digits.length === 7) {
        return `${digits.substring(0, 1)}.${digits.substring(1, 4)}.${digits.substring(4, 7)}-${checksum}`;
      } else {
        return `${digits.substring(0, 2)}.${digits.substring(2, 5)}.${digits.substring(5, 8)}-${checksum}`;
      }
    }
    
    return digits + checksum;
  }
}